import cls from "classname"

import Images from "../../../../Images"

import "./DataSourceSwitcher.less"

const options = [
  {
    icon: <img src={Images.switcher_stripe} alt="Stripe" height={20} width={20} />,
    value: "stripe"
  },
  {
    icon: <img src={Images.switcher_shopify} alt="Shopify" width={20} height={20} />,
    value: "shopify"
  }
]

// CHA1-4421 (item 3): the source switcher must expose tab semantics (role="tablist"/"tab"),
// not AntD Segmented's radiogroup. Native tablist keeps the pill look via the LESS below.
const DataSourceSwitcher = ({ dataSource, onSwitch, loading, disabled = false }) => {
  const isDisabled = loading || disabled

  return (
    <div
      role="tablist"
      className={cls("bh-data-source-switcher", { "bh-data-source-switcher--loading": loading })}
    >
      {options.map((option) => {
        const selected = dataSource === option.value
        return (
          <button
            key={option.value}
            type="button"
            role="tab"
            aria-selected={selected}
            tabIndex={selected ? 0 : -1}
            disabled={isDisabled}
            onClick={() => onSwitch(option.value)}
            className={cls("bh-data-source-switcher__tab", {
              "bh-data-source-switcher__tab--active": selected
            })}
          >
            {option.icon}
          </button>
        )
      })}
    </div>
  )
}

export default DataSourceSwitcher
